import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';

const MODULE_NAME = 'WEBSITE_SORT_MODULE';

export interface UnitAvailabilityDaysPayload {
  from: string;
  to: string;
  fixedEndDate: boolean;
  areaId?: string;
  propertyId?: string;
}

export interface UnitAvailabilityDaysResult {
  processedRooms: number;
  upserted: number;
}

export interface UnitAvailabilityDaysResponse extends ResponseModel<UnitAvailabilityDaysResult> {
  message: string;
}

export interface UnitAvailabilityDaysLastRun {
  key: string;
  from: string;
  to: string;
  fixedEndDate?: boolean;
  lastRequestedAt: string;
  lastCalculatedAt: string;
  isActive: boolean;
  areaName?: string | null;
  propertyName?: string | null;
  cityName?: string | null;
}

export interface UnitAvailabilityDaysLastRunResponse
  extends ResponseModel<UnitAvailabilityDaysLastRun[]> {
  message: string;
}

export function calculateUnitAvailabilityDays(
  payload: UnitAvailabilityDaysPayload
): Promise<UnitAvailabilityDaysResponse | ErrorInfo> {
  return api.calculateUnitAvailabilityDays(payload).then((response) => {
    if (response.ok && response.data) {
      return response.data as UnitAvailabilityDaysResponse;
    }

    const errorResponse = response.data as ErrorInfo | undefined;

    return errorHelper(
      Number(response.status),
      errorResponse?.errorCode ? String(errorResponse.errorCode) : response.problem || '',
      MODULE_NAME,
      (api.calculateUnitAvailabilityDays as any).displayName
    );
  });
}

export function getUnitAvailabilityDaysLastRun(): Promise<
  UnitAvailabilityDaysLastRunResponse | ErrorInfo
> {
  return api.getUnitAvailabilityDaysLastRun().then((response) => {
    if (response.ok && response.data) {
      return response.data as UnitAvailabilityDaysLastRunResponse;
    }

    const errorResponse = response.data as ErrorInfo | undefined;

    return errorHelper(
      Number(response.status),
      errorResponse?.errorCode ? String(errorResponse.errorCode) : response.problem || '',
      MODULE_NAME,
      (api.getUnitAvailabilityDaysLastRun as any).displayName
    );
  });
}
